var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopsimilarcities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.35 28.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f363f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.78,410.46H336.31v-4h15.47ZM344,397a14.18,14.18,0,1,1-14.18,14.18A14.17,14.17,0,0,1,344,397Zm0,.28A13.92,13.92,0,1,0,358,411.16,13.9,13.9,0,0,0,344,397.26Zm6.74,10.16H337.29v2h13.48Zm1,8.52H336.31v-4.05h15.47Zm-1-3H337.29v2h13.48Z",
    transform: "translate(-329.85 -396.98)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopsimilarcities);
export default __webpack_public_path__ + "static/media/topsimilarcities.185fcd46f4b422db8554ded9b851d9f7.svg";
export { ForwardRef as ReactComponent };